export const ROLES = {
    Employees: 'employee',
    Manager: 'manager',
    Admin: 'admin',
}